import { defineGlobals } from "vue-utils"
import { MarriageService } from "./MarriageClaims"

const Api = {
	marriageClaims: new MarriageService(),
}

defineGlobals({ Api })

export default Api
